// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__-PSeG","Centralizer_unique":"Spinner_Centralizer_unique__6ia4m"};